import { gql } from '@apollo/client';

// mto = Maximum Tolerable Outage
// rpo = Recovery Point Objective
// sto = Shutdowns, Turnarounds, and Outages
// sla = Service Level Agreement
// drp = Disaster Recovery Plan

export const FETCH_IT_APPLICATIONS = gql`
  query FindAllItApplications($data: FilterInput) {
    findAllItApplications(data: $data) {
      HostingLocationsAsset {
        ITApllicationsEntity {
          application
          applicationType
          description
          drpDate
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        ITApplicationsAsset {
          application
          applicationType
          description
          drpDate
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      HostingLocationsEntity {
        tier {
          id
          name
          color
        }
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      application
      applicationType
      description
      drpDate
      drpLink
      drpInPlace
      lastDrpTest
      mto
      rpo
      rto
      sla
      supportsEmployees
      supportsLifeSafety
      supportsOther
      supportsRegulation
      supportsReputation
      supportsRevenue
      uuid
      tier {
        id
        name
        color
      }
    }
  }
`;

export const CREATE_IT_APPLICATION = gql`
  mutation CreateItApplication($data: CreateItApplicationInput!) {
    createItApplication(data: $data) {
      HostingLocationsAsset {
        ITApllicationsEntity {
          application
          applicationType
          description
          drpDate
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        ITApplicationsAsset {
          application
          applicationType
          description
          drpDate
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        tier {
          id
          name
          color
        }
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      HostingLocationsEntity {
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        tier {
          id
          name
          color
        }
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      application
      applicationType
      description
      drpDate
      drpLink
      lastDrpTest
      mto
      rpo
      rto
      sla
      supportsEmployees
      supportsLifeSafety
      supportsOther
      supportsRegulation
      supportsReputation
      supportsRevenue
      uuid
      tier {
        id
        name
        color
      }
    }
  }
`;

export const UPDATE_IT_APPLICATION = gql`
  mutation UpdateItApplication($data: UpdateItApplicationInput!) {
    updateItApplication(data: $data) {
      HostingLocationsAsset {
        ITApllicationsEntity {
          application
          applicationType
          description
          drpDate
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        ITApplicationsAsset {
          application
          applicationType
          description
          drpDate
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        tier {
          id
          name
          color
        }
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      HostingLocationsEntity {
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        tier {
          id
          name
          color
        }
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      application
      applicationType
      description
      drpDate
      drpLink
      lastDrpTest
      mto
      rpo
      rto
      sla
      supportsEmployees
      supportsLifeSafety
      supportsOther
      supportsRegulation
      supportsReputation
      supportsRevenue
      uuid
      tier {
        id
        name
        color
      }
    }
  }
`;

export const DELETE_IT_APPLICATION = gql`
  mutation DeleteItApplication($uuid: ID!) {
    deleteItApplication(uuid: $uuid) {
      HostingLocationsAsset {
        ITApllicationsEntity {
          application
          applicationType
          description
          drpDate
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        ITApplicationsAsset {
          application
          applicationType
          description
          drpDate
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        tier {
          id
          name
          color
        }
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      HostingLocationsEntity {
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        tier {
          id
          name
          color
        }
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      application
      applicationType
      description
      drpDate
      drpLink
      lastDrpTest
      mto
      rpo
      rto
      sla
      supportsEmployees
      supportsLifeSafety
      supportsOther
      supportsRegulation
      supportsReputation
      supportsRevenue
      uuid
    }
  }
`;

export const GET_SELECTED_IT_APPS = gql`
  query GetSelectedItApplications {
    getSelectedItApplications {
      HostingLocationsAsset {
        ITApllicationsEntity {
          application
          applicationType
          comment
          description
          drpDate
          drpInPlace
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        ITApplicationsAsset {
          application
          applicationType
          comment
          description
          drpDate
          drpInPlace
          drpLink
          lastDrpTest
          mto
          rpo
          rto
          sla
          supportsEmployees
          supportsLifeSafety
          supportsOther
          supportsRegulation
          supportsReputation
          supportsRevenue
          uuid
        }
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        tier {
          id
          name
          color
        }
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      HostingLocationsEntity {
        address
        businessOwnerEmail
        businessOwnerName
        drInPlace
        tier {
          id
          name
          color
        }
        hostingAssetOrServer
        hostingEntityName
        itOwnerEmail
        itOwnerName
        rebuildTime
        type
        uuid
      }
      application
      applicationType
      comment
      description
      drpDate
      drpInPlace
      drpLink
      lastDrpTest
      mto
      rpo
      rto
      sla
      supportsEmployees
      supportsLifeSafety
      supportsOther
      supportsRegulation
      supportsReputation
      supportsRevenue
      uuid
    }
  }
`;

export const GET_BUSINESS_FUNCTIONS_SELECTED_IT_APPS = gql`
  query GetBusinessFunctionsSelectedItApplications($data: [String!]!) {
    getBusinessFunctionsSelectedItApplications(data: $data) {
      itApplications {
        HostingLocationsAsset {
          ITApllicationsEntity {
            application
            applicationType
            comment
            description
            drpDate
            drpInPlace
            drpLink
            lastDrpTest
            mto
            rpo
            rto
            sla
            supportsEmployees
            supportsLifeSafety
            supportsOther
            supportsRegulation
            supportsReputation
            supportsRevenue
            uuid
          }
          ITApplicationsAsset {
            application
            applicationType
            comment
            description
            drpDate
            drpInPlace
            drpLink
            lastDrpTest
            mto
            rpo
            rto
            sla
            supportsEmployees
            supportsLifeSafety
            supportsOther
            supportsRegulation
            supportsReputation
            supportsRevenue
            uuid
          }
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        HostingLocationsEntity {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        application
        applicationType
        comment
        description
        drpDate
        drpInPlace
        drpLink
        lastDrpTest
        mappingComment
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      uuid
    }
  }
`;

export const GET_SELECTED_IT_APPS_DESCRIPTION = gql`
  query GetSelectedItApplications($data: String!) {
    getSelectedItApplications(data: $data) {
      uuid
      application
      applicationType
      comment
      description
    }
  }
`;

export const SET_IT_APPLICATIONS_TO_BIZ_FUNCTIONS = gql`
  mutation SetItApplicationsTobusinesFunctions(
    $data: ItApplicationsMappingInput!
  ) {
    setItApplicationsTobusinesFunctions(data: $data)
  }
`;

export const SET_BUSINESS_FUNCTION_IT_APP_COMMENT = gql`
  mutation SetBusinessFunctionMappingComment($data: MappingCommentInput!) {
    setBusinessFunctionMappingComment(data: $data)
  }
`;

export const SET_LOCATION_BUSINESS_FUNCTION_IT_APP_COMMENT = gql`
  mutation SetLocationBusinessFunctionMappingComment(
    $data: MappingLocationBusinessFunctionCommnetInput!
  ) {
    setLocationBusinessFunctionMappingComment(data: $data)
  }
`;

export const GET_LOCATION_BUSINESS_FUNCTIONS_SELECTED_IT_APPS = gql`
  query GetLocationBusinessFunctionsSelectedItApplications(
    $data: LocationBusinessFunctionsInput!
  ) {
    getLocationBusinessFunctionsSelectedItApplications(data: $data) {
      itApplications {
        HostingLocationsAsset {
          ITApllicationsEntity {
            application
            applicationType
            comment
            description
            drpDate
            drpInPlace
            drpLink
            lastDrpTest
            mto
            rpo
            rto
            sla
            supportsEmployees
            supportsLifeSafety
            supportsOther
            supportsRegulation
            supportsReputation
            supportsRevenue
            uuid
          }
          ITApplicationsAsset {
            application
            applicationType
            comment
            description
            drpDate
            drpInPlace
            drpLink
            lastDrpTest
            mto
            rpo
            rto
            sla
            supportsEmployees
            supportsLifeSafety
            supportsOther
            supportsRegulation
            supportsReputation
            supportsRevenue
            uuid
          }
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        HostingLocationsEntity {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        application
        applicationType
        comment
        description
        drpDate
        drpInPlace
        drpLink
        lastDrpTest
        mappingComment
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      uuid
    }
  }
`;
